export enum MenuEvents {
  TOGGLE_MENU = 'app-space:toggleMenu'
}
